import script from "./GalleryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryPage.vue?vue&type=script&setup=true&lang=js"

import "./GalleryPage.vue?vue&type=style&index=0&id=b690d4e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b690d4e6"]])

export default __exports__